<template>
  <div class="product-import">
    <div class="container view">
      <div class="product-import__wrapper">
        <Card tag="form" @submit.prevent="submit" class="product-import__form">
          <template #header>
            <h1>{{ $t('contactImport') }}</h1>
          </template>
          <template #default>
            <FileComponent v-model="file" :upload="fileHandler" :label="$tc('file') + ' (CSV)'" />
            <Alert theme="primary" class="mt-2">
              <template>
                <a :href="downloadTemplateUrl" target="_blank">{{ $t('downloadTemplate') }}</a>
                {{ $t('importTemplateDescription') }}
              </template>
            </Alert>
          </template>
          <template #footer>
            <ButtonComponent
              type="submit"
              :label="$t('import')"
              :promise="promise"
              :disabled="!file || (response && !response.failed)"
              :icon="['fal', 'arrow-to-right']"
              theme="primary"
            />
          </template>
        </Card>
        <Alert v-if="response" :theme="response.failed ? 'error' : 'success'" class="mt-2">
          <template v-if="response.failed">
            <div class="mb-1">{{ $t('importFailedResolveIssues') }}</div>
            <div style="word-break: break-all">{{ errors }}</div>
          </template>
          <template v-else>
            {{
              $t('importedXItem', { count: response.imported, item: $tc('contact', response.imported).toLowerCase() })
            }}
          </template>
        </Alert>
      </div>
    </div>
  </div>
</template>

<script>
import Card from '@/components/Card'
import { FileComponent } from '@kvass/file'
import { AlertComponent as Alert } from 'vue-elder-alert'

const templateUrl = {
  nb: `https://docs.google.com/spreadsheets/d/1dbLwNtPTreU-r8RzwCLbUMJxoFJxdBcVmOHNtyoVHSw/edit?usp=sharing`,
  en: 'https://docs.google.com/spreadsheets/d/1FIVUa08LnsnkDc72IJdgIgEA3rCvmrYWsYEAdtdzL7o/edit?usp=sharing',
}

export default {
  props: {
    language: {
      type: String,
      default: 'en',
    },
  },
  data() {
    return {
      file: null,
      response: null,
      promise: null,
    }
  },
  computed: {
    downloadTemplateUrl() {
      return templateUrl[this.language] || templateUrl['en']
    },

    errors() {
      if (!this.response || !this.response.failed) return
      return JSON.stringify(this.response.details.error, null, { space: '  ' })
    },
  },
  methods: {
    async fileHandler(file) {
      this.response = null
      if (!file) return
      return {
        name: file.name,
        size: file.size,
        type: file.type,
        value: file,
        url: '#',
      }
    },
    upload(options = {}) {
      let { dry = true } = options

      if (!this.file) return Promise.reject(new Error('Missing file'))

      return new Promise((resolve, reject) => {
        let url = '/api/import/contact'
        if (!dry) url += '?run=true'
        let data = new FormData()
        data.append('file', this.file.value)

        let xhr = new XMLHttpRequest()
        xhr.responseType = 'json'
        xhr.onreadystatechange = function () {
          if (this.readyState !== 4) return
          if (this.status >= 200 && this.status <= 400) return resolve(xhr.response)
          return reject(xhr.response)
        }
        xhr.open('POST', url)
        xhr.send(data)
      })
    },
    submit() {
      this.promise = this.upload()
        .then(data => {
          if (!data.failed && data.dry) return this.upload({ dry: false })
          return data
        })
        .then(data => {
          this.response = data
        })
    },
  },
  metaInfo() {
    return {
      title: this.$t('contactImport'),
    }
  },
  components: {
    Card,
    FileComponent,
    Alert,
  },
}
</script>

<style lang="scss">
.product-import {
  background-color: $background-grey;

  h1 {
    margin: 0;
  }

  &__wrapper {
    max-width: 600px;
    margin: 0 auto;
  }
}
</style>
